import React from "react";
import styled from "styled-components";
import { FaEdit, FaSync } from "react-icons/fa";
import { toast } from "react-toastify";
import { DataHora } from "./DadosRodada";
import api from "../api";

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 380px;
`;

export const Thead = styled.thead`
  background-color: #1a5276;
  color: white;
`;
export const Tbody = styled.tbody``;
export const Tr = styled.tr`
  border-bottom: 1px solid #f0f0f0;
  &:last-child { border-bottom: none; }
`;

export const Th = styled.th`
  text-align: start;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none"}
  }
`;

export const Td = styled.td`
  padding: 10px 12px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  font-size: 14px;
  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none"}
    padding: 8px 8px;
  }
`;

const GridRodadas = ({ users, setUsers, setOnEdit, getUsers }) => {
  const handleEdit = (item) => {
    setOnEdit(item);
  };

  const handleCarga = async (item) => {
    try {
      const response = await api.put(`liga/addTimesNaRodada/${item.id}/${item.idLiga}`);
      toast.success("Carga realizada com sucesso");
      if (getUsers) getUsers();
    } catch (error) {
      toast.error("Não foi possível realizar a carga");
    }
  };

  return (
    <TableWrapper>
      <Table>
        <Thead>
          <Tr>
            <Th>Rod</Th>
            <Th onlyWeb>Vl Part</Th>
            <Th onlyWeb>Vl Rodada</Th>
            <Th onlyWeb>Início</Th>
            <Th onlyWeb>Fim</Th>
            <Th style={{ textAlign: "center" }}>Carga</Th>
            <Th style={{ textAlign: "center" }}>[]</Th>
          </Tr>
        </Thead>
        <Tbody>
          {users.map((item, i) => (
            <Tr key={i}>
              <Td>{item.rodada}</Td>
              <Td onlyWeb>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(item.valorParticipante)}</Td>
              <Td onlyWeb>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(item.valorRodada)}</Td>
              <Td onlyWeb>{DataHora(item.inicio)}</Td>
              <Td onlyWeb>{DataHora(item.fim)}</Td>
              <Td alignCenter>
                <FaSync
                  style={{ cursor: "pointer", color: "#2980b9" }}
                  title="Carregar times na rodada"
                  onClick={() => handleCarga(item)}
                />
              </Td>
              <Td alignCenter>
                <FaEdit
                  style={{ cursor: "pointer", color: "#666" }}
                  onClick={() => handleEdit(item)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableWrapper>
  );
};

export default GridRodadas;

